<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Manage Product Subcategories</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <div class="modal-card-body has-text-centered">

          <v-select
            v-if="categories" 
            :options="categories"
            item-value="id"
            item-text="category"
            v-model="categoryId"/>

          <article 
            v-if="subcategories.length == 0" 
            class="message is-info is-fullwidth mt-3">
            <div class="message-body">
              There are no subcategories
            </div>
          </article>

          <!-- existing subcategory -->
          <div class="panel mt-3" v-if="subcategories.length > 0">
            <a class="panel-block" 
              v-for="subcategory in subcategories"
              :key="subcategory.id">
              <div class="row-justified is-fullwidth">

                <div v-if="subcategory.id != editingId">
                  {{ subcategory.subcategory }}
                </div>
                <v-text-field 
                  v-else
                  required
                  placeholder="Enter Subcategory"
                  v-model="subcategory.subcategory"
                  @blur="updateSubcategory({ 
                    subcategoryId: subcategory.id, 
                    data: { subcategory: subcategory.subcategory }
                  })"/>

                <div class="buttons">
                  <button 
                    @click="toggleEdit(subcategory.id)"
                    class="button is-small">
                    <span class="icon">
                      <i class="fas fa-edit has-text-grey"></i>
                    </span>
                  </button>
                  <button 
                    @click="launchConfirmDelete(subcategory.id)"
                    class="button is-small">
                    <span class="icon">
                      <i class="fas fa-trash has-text-grey"></i>
                    </span>
                  </button>
                </div>

              </div>
            </a>
          </div>

          <!-- adding new subcategory -->
          <div v-if="adding">
            <v-form :valid.sync="valid" class="pb-2">
              <v-text-field 
                required
                placeholder="Enter subcategory"
                v-model="subcategory"/>
            </v-form>

            <div class="buttons">
              <button 
                :disabled="!valid"
                @click="addNew()"
                class="button is-primary is-small">
                <span class="icon">
                  <i class="fas fa-save"></i>
                </span>
                <span>Save new Subcategory</span>
              </button>
              <button 
                @click="adding = false"
                class="button is-small">
                <span class="icon">
                  <i class="fas fa-times has-text-grey"></i>
                </span>
                <span>Exit Add Subcategory</span>
              </button>
            </div>
          </div>

          <button 
            v-if="!adding"
            class="button is-primary is-small" 
            @click="adding = true; editingId = null">
            Add a Subcategory
          </button>

        </div>

      </div>

      <v-confirm-modal 
        v-model="confirmDelete.state"
        :title="confirmDelete.title"
        :message="confirmDelete.message"
        :type="confirmDelete.type"
        @confirm="deleteConfirmedCb()"
        @cancel="confirmDelete.state = false"/>

    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'
import VConfirmModal from '@/components/base/VConfirmModal'
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { VTextField, VForm, VSelect, VConfirmModal },
  data() {
    return {
      valid: false,
      categoryId: null,
      subcategory: null,
      adding: false,
      editingId: null,
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this subcategory?',
        type: 'danger'
      },
      deleteConfirmedCb: null,
    }
  },
  computed: {
    ...mapState("products", ["categories", "subcategories"])
  },
  watch: {
    categoryId(id) {
      this.editingId = null;
      this.getSubcategories({ product_category_id: id });
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("products", [
      "getCategories", "getSubcategories", "addSubcategory", 
      "updateSubcategory", "deleteSubcategory"
    ]),
    initialize() {
      if (this.categories.length == 0) {
        this.getCategories().then(resp => {
          this.categoryId = resp.data.results[0].id;
          this.getSubcategories({ product_category_id: this.categoryId });
        })
      }
    },
    addNew() {
      this.addSubcategory({ 
        subcategory: this.subcategory,
        product_category_id: this.categoryId
      }).then(() => {
        this.subcategory = null;
        this.adding = false;
      });
    },
    toggleEdit(id) {
      if (this.editingId == id) {
        this.editingId = null;
      } else {
        this.editingId = id;
      }
    },
    launchConfirmDelete(subcategoryId) {
      this.deleteConfirmedCb = () => {
        this.deleteSubcategory(subcategoryId);
        this.confirmDelete.state = false;
      }
      this.confirmDelete.state = true;
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
.row-justified {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
}

.modal-card {
  border-radius: 6px;
}
</style>